import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/config";
import { Reveal } from "../components/Motion";
import Seo from "../components/Seo";

const CATEGORIES = ["all", "destination-guides", "travel-tips", "trip-recaps"];

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/blogs").then((r) => setBlogs(r.data)); }, []);
  const filtered = useMemo(() => cat === "all" ? blogs : blogs.filter((b) => b.category === cat), [blogs, cat]);

  return (
    <div className="pt-28 md:pt-36 pb-16" data-testid="blog-page">
      <Seo
        title="Journal"
        description="Field notes from the road — destination guides, travel tips and trip recaps from Once Way Travel's journeys across the world."
        path="/blog"
      />
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal>
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-owt-muted mb-4">· The Journal</div>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.9] text-owt-forest">Field notes,<br/><span className="italic text-owt-terracotta">from the road.</span></h1>
        </Reveal>

        <div className="mt-10 flex flex-wrap gap-2 border-b border-owt-border pb-6" data-testid="blog-filters">
          {CATEGORIES.map((c) => (
            <button
              key={c} onClick={() => setCat(c)}
              data-testid={`blog-cat-${c}`}
              className={`font-mono text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 border transition-colors ${cat === c ? "bg-owt-forest text-owt-surface border-owt-forest" : "border-owt-border text-owt-forest hover:border-owt-forest"}`}
            >{c.replace(/-/g, " ")}</button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {filtered.map((b, i) => (
            <Reveal key={b.id} delay={i * 0.06}>
              <Link to={`/blog/${b.slug}`} className="group block" data-testid={`blog-card-${b.slug}`}>
                <div className="aspect-[4/3] overflow-hidden bg-owt-sand">
                  <motion.img src={b.cover_image} alt={b.title} className="w-full h-full object-cover" whileHover={{ scale: 1.05 }} transition={{ duration: 1 }}/>
                </div>
                <div className="mt-4">
                  <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-owt-terracotta">{b.category.replace(/-/g, " ")} · {b.read_time} min · {b.author}</div>
                  <h3 className="font-display text-2xl text-owt-forest mt-2 group-hover:text-owt-terracotta transition-colors leading-tight">{b.title}</h3>
                  <p className="text-owt-muted mt-2">{b.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
